'use client';

import React from 'react';
import {
  DynamicWidgets,
  ClearRefinements,
  RefinementList,
  // eslint-disable-next-line import/no-unresolved
} from 'react-instantsearch-next';

const AdvancedSearchSidebar = () => (
  <div>
    <DynamicWidgets>
      <RefinementList attribute="type" />
    </DynamicWidgets>
    <ClearRefinements />
  </div>
);

export default AdvancedSearchSidebar;
